// Mounts the lock screen with "Switch cashier" wired to the same logout the
// side menu uses (useSuperMarketHandlers.handleLogout), so the parked-bill and
// open-cart checks, close-till and sign-in all behave as they do there. Only
// mounted while the till is locked; the hook holds no effects.
import React, { useState } from "react";
import FashionLockScreen from "./FashionLockScreen";
import useSuperMarketHandlers from "../Retail/SuperMarket/useSuperMarketHandlers";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";

const domainURL = process.env.REACT_APP_domain;

const FashionLockGate = ({ hostProps, lockKey, billOpen, ...lockProps }) => {
  const [switching, setSwitching] = useState(false);
  const posConfigData = { posType: usePOSConfigStore.getState().posType };
  const pricePrecision = hostProps?.tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision ?? 2;
  const { handleLogout } = useSuperMarketHandlers({ ...hostProps, pricePrecision, posConfigData, domainURL });

  const switchCashier = async () => {
    // The next cashier must not land on this cashier's lock.
    try {
      localStorage.removeItem(lockKey);
    } catch {
      // per-viewer convenience only
    }
    await handleLogout(setSwitching);
  };

  return (
    <FashionLockScreen
      {...lockProps}
      onSwitchCashier={switchCashier}
      switching={switching}
      switchBlocked={billOpen ? "Unlock and finish or park the open bill before switching cashier." : null}
    />
  );
};

export default FashionLockGate;
